const links = [
  { label: "Email", url: "ricetsengtw@gmail.com", href: "mailto:ricetsengtw@gmail.com" },
  { label: "LinkedIn", url: "linkedin.com/in/ricetseng", href: "https://www.linkedin.com/in/ricetseng/" },
  { label: "X / Twitter", url: "@ricetseng", href: "https://x.com/ricetseng" },
  { label: "Medium", url: "medium.com/@ricetseng_0820", href: "https://medium.com/@ricetseng_0820" },
]

export default function Contact() {
  return (
    <div className="page-panel">
      <div className="panel-inner">

        <div className="panel-header">
          <div className="panel-tag">Contact</div>
          <h2 className="panel-title">Let's<br />Talk</h2>
        </div>

        <div className="contact-grid">
          <div className="contact-cta">
            Open to conversations about <em>design leadership,</em> consulting
            engagements, speaking, mentoring, and{" "}
            <em>interesting product problems.</em>
          </div>
          <div>
            <ul className="contact-links">
              {links.map((link) => (
                <li key={link.label} className="contact-link-item">
                  <a
                    href={link.href}
                    className="contact-link"
                    target={link.href.startsWith("mailto") ? undefined : "_blank"}
                    rel="noopener noreferrer"
                  >
                    <span className="contact-link-label">{link.label}</span>
                    <span className="contact-link-url">{link.url}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="section-divider" />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: "12px",
            color: "var(--fg-faint)",
            letterSpacing: "0.08em",
          }}
        >
          <span>Rice Tseng · Portfolio {new Date().getFullYear()}</span>
          <span>Singapore</span>
        </div>

      </div>
    </div>
  )
}
